import { Typography } from 'antd';
import { memo } from 'react';

import { OutlinedRightArrowIcon } from '@shared/assets-icon';
import { getInstitutionLogoPath } from '@shared/utils/institution';

interface Props {
  icon: string;
  name: string;
  onClick: () => void;
}
const { Text } = Typography;

const InstitutionCard = ({ icon, name, onClick }: Props) => (
  <div
    className="flex min-h-16 cursor-pointer justify-between border-b border-functional-stone bg-white px-4 py-2 "
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        onClick();
      }
    }}
    role="button"
    tabIndex={0}
  >
    <div className="flex items-center">
      <img alt="" className="mr-4 w-8px" src={getInstitutionLogoPath(icon)} />
      <Text className="text-base font-semibold">{name}</Text>
    </div>
    <div className="flex items-center">
      <OutlinedRightArrowIcon className="size-6px" />
    </div>
  </div>
);

export default memo(InstitutionCard);
